export const biodataType = {
	title: 'বায়োডাটার ধরন*',
	selected: {
		option: '----',
		value: ''
	},
	options: ['পাত্রের বায়োডাটা', 'পাত্রীর বায়োডাটা'],
};

export const maritalStatus = {
	title: 'বৈবাহিক অবস্থা*',
	selected: {
		option: '----',
		value: '',
	},
	options: ['অবিবাহিত', 'বিবাহিত', 'ডিভোর্সড', 'বিধবা', 'বিপত্নীক'],
};

export const birthYear = {
	title: 'জন্মসন (আসল)*',
	selected: {
		option: '----',
		value: '',
	},
	optionsValue: [
		{
			option: '১৯৬০',
			value: 1960,
		},
		{
			option: '১৯৬১',
			value: 1961,
		},
		{
			option: '১৯৬২',
			value: 1962,
		},
		{
			option: '১৯৬৩',
			value: 1963,
		},
		{
			option: '১৯৬৪',
			value: 1964,
		},
		{
			option: '১৯৬৫',
			value: 1965,
		},
		{
			option: '১৯৬৬',
			value: 1966,
		},
		{
			option: '১৯৬৭',
			value: 1967,
		},
		{
			option: '১৯৬৮',
			value: 1968,
		},
		{
			option: '১৯৬৯',
			value: 1969,
		},
		{
			option: '১৯৭০',
			value: 1970,
		},
		{
			option: '১৯৭১',
			value: 1971,
		},
		{
			option: '১৯৭২',
			value: 1972,
		},
		{
			option: '১৯৭৩',
			value: 1973,
		},
		{
			option: '১৯৭৪',
			value: 1974,
		},
		{
			option: '১৯৭৫',
			value: 1975,
		},
		{
			option: '১৯৭৬',
			value: 1976,
		},
		{
			option: '১৯৭৭',
			value: 1977,
		},
		{
			option: '১৯৭৮',
			value: 1978,
		},
		{
			option: '১৯৭৯',
			value: 1979,
		},
		{
			option: '১৯৮০',
			value: 1980,
		},
		{
			option: '১৯৮১',
			value: 1981,
		},
		{
			option: '১৯৮২',
			value: 1982,
		},
		{
			option: '১৯৮৩',
			value: 1983,
		},
		{
			option: '১৯৮৪',
			value: 1984,
		},
		{
			option: '১৯৮৫',
			value: 1985,
		},
		{
			option: '১৯৮৬',
			value: 1986,
		},
		{
			option: '১৯৮৭',
			value: 1987,
		},
		{
			option: '১৯৮৮',
			value: 1988,
		},
		{
			option: '১৯৮৯',
			value: 1989,
		},
		{
			option: '১৯৯০',
			value: 1990,
		},
		{
			option: '১৯৯১',
			value: 1991,
		},
		{
			option: '১৯৯২',
			value: 1992,
		},
		{
			option: '১৯৯৩',
			value: 1993,
		},
		{
			option: '১৯৯৪',
			value: 1994,
		},
		{
			option: '১৯৯৫',
			value: 1995,
		},
		{
			option: '১৯৯৬',
			value: 1996,
		},
		{
			option: '১৯৯৭',
			value: 1997,
		},
		{
			option: '১৯৯৮',
			value: 1998,
		},
		{
			option: '১৯৯৯',
			value: 1999,
		},
		{
			option: '২০০০',
			value: 2000,
		},
		{
			option: '২০০১',
			value: 2001,
		},
		{
			option: '২০০২',
			value: 2002,
		},
		{
			option: '২০০৩',
			value: 2003,
		},
		{
			option: '২০০৪',
			value: 2004,
		},
		{
			option: '২০০৫',
			value: 2005,
		},
		{
			option: '২০০৬',
			value: 2006,
		},
		{
			option: '২০০৭',
			value: 2007,
		},
		{
			option: '২০০৮',
			value: 2008,
		},
		{
			option: '২০০৯',
			value: 2009,
		},
		{
			option: '২০১০',
			value: 2010,
		},
		{
			option: '২০১১',
			value: 2011,
		},
		{
			option: '২০১২',
			value: 2012,
		},
		{
			option: '২০১৩',
			value: 2013,
		},
		{
			option: '২০১৪',
			value: 2014,
		},
		{
			option: '২০১৫',
			value: 2015,
		},
		// {
		// 	option: '২০১৬',
		// 	value: 2016,
		// },
		// {
		// 	option: '২০১৭',
		// 	value: 2017,
		// },
		// {
		// 	option: '২০১৮',
		// 	value: 2018,
		// },
		// {
		// 	option: '২০১৯',
		// 	value: 2019,
		// },
		// {
		// 	option: '২০২০',
		// 	value: 2020,
		// },
		// {
		// 	option: '২০২১',
		// 	value: 2021,
		// },
		// {
		// 	option: '২০২২',
		// 	value: 2022,
		// },
		// {
		// 	option: '২০২৩',
		// 	value: 2023,
		// },
		// {
		// 	option: '২০২৪',
		// 	value: 2024,
		// },
		// {
		// 	option: '২০২৫',
		// 	value: 2025,
		// },
	],
};

export const skinColor = {
	title: 'গাত্রবর্ণ*',
	selected: {
		option: '----',
		value: '',
	},
	options: ['কালো', 'শ্যামলা', 'উজ্জ্বল শ্যামলা', 'ফর্সা', 'উজ্জ্বল ফর্সা'],
};

export const height = {
	title: 'উচ্চতা*',
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'৪\'০"',
		'৪\'১"',
		'৪\'২"',
		'৪\'৩"',
		'৪\'৪"',
		'৪\'৫"',
		'৪\'৬"',
		'৪\'৭"',
		'৪\'৮"',
		'৪\'৯"',
		'৪\'১০"',
		'৪\'১১"',
		'৫\'০"',
		'৫\'১"',
		'৫\'২"',
		'৫\'৩"',
		'৫\'৪"',
		'৫\'৫"',
		'৫\'৬"',
		'৫\'৭"',
		'৫\'৮"',
		'৫\'৯"',
		'৫\'১০"',
		'৫\'১১"',
		'৬\'০"',
		'৬\'১"',
		'৬\'২"',
		'৬\'৩"',
		'৬\'৪"',
		'৬\'৫"',
		'৬\'৬"',
		'৬\'৭"',
		'৬\'৮"',
		'৬\'৯"',
		'৬\'১০"',
		'৬\'১১"',
		'৭\'০"',
		'৭\'১"',
		'৭\'২"',
		'৭\'৩"',
		'৭\'৪"',
		'৭\'৫"',
		// '৭\'৬"',
		// '৭\'৭"',
		// '৭\'৮"',
		// '৭\'৯"',
		// '৭\'১০"',
		// '৭\'১১"',
	],
};

export const weight = {
	title: 'ওজন (কেজি)*',
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'৩০ কেজি',
		'৩১ কেজি',
		'৩২ কেজি',
		'৩৩ কেজি',
		'৩৪ কেজি',
		'৩৫ কেজি',
		'৩৬ কেজি',
		'৩৭ কেজি',
		'৩৮ কেজি',
		'৩৯ কেজি',
		'৪০ কেজি',
		'৪১ কেজি',
		'৪২ কেজি',
		'৪৩ কেজি',
		'৪৪ কেজি',
		'৪৫ কেজি',
		'৪৬ কেজি',
		'৪৭ কেজি',
		'৪৮ কেজি',
		'৪৯ কেজি',
		'৫০ কেজি',
		'৫১ কেজি',
		'৫২ কেজি',
		'৫৩ কেজি',
		'৫৪ কেজি',
		'৫৫ কেজি',
		'৫৬ কেজি',
		'৫৭ কেজি',
		'৫৮ কেজি',
		'৫৯ কেজি',
		'৬০ কেজি',
		'৬১ কেজি',
		'৬২ কেজি',
		'৬৩ কেজি',
		'৬৪ কেজি',
		'৬৫ কেজি',
		'৬৬ কেজি',
		'৬৭ কেজি',
		'৬৮ কেজি',
		'৬৯ কেজি',
		'৭০ কেজি',
		'৭১ কেজি',
		'৭২ কেজি',
		'৭৩ কেজি',
		'৭৪ কেজি',
		'৭৫ কেজি',
		'৭৬ কেজি',
		'৭৭ কেজি',
		'৭৮ কেজি',
		'৭৯ কেজি',
		'৮০ কেজি',
		'৮১ কেজি',
		'৮২ কেজি',
		'৮৩ কেজি',
		'৮৪ কেজি',
		'৮৫ কেজি',
		'৮৬ কেজি',
		'৮৭ কেজি',
		'৮৮ কেজি',
		'৮৯ কেজি',
		'৯০ কেজি',
		'৯১ কেজি',
		'৯২ কেজি',
		'৯৩ কেজি',
		'৯৪ কেজি',
		'৯৫ কেজি',
		'৯৬ কেজি',
		'৯৭ কেজি',
		'৯৮ কেজি',
		'৯৯ কেজি',
		'১০০ কেজি',
		'১০১ কেজি',
		'১০২ কেজি',
		'১০৩ কেজি',
		'১০৪ কেজি',
		'১০৫ কেজি',
		'১০৬ কেজি',
		'১০৭ কেজি',
		'১০৮ কেজি',
		'১০৯ কেজি',
		'১১০ কেজি',
		'১১১ কেজি',
		'১১২ কেজি',
		'১১৩ কেজি',
		'১১৪ কেজি',
		'১১৫ কেজি',
		'১১৬ কেজি',
		'১১৭ কেজি',
		'১১৮ কেজি',
		'১১৯ কেজি',
		'১২০ কেজি',
		'১২১ কেজি',
		'১২২ কেজি',
		'১২৩ কেজি',
		'১২৪ কেজি',
		'১২৫ কেজি',
		'১২৬ কেজি',
		'১২৭ কেজি',
		'১২৮ কেজি',
		'১২৯ কেজি',
		'১৩০ কেজি',
	],
};

export const bloodGroup = {
	title: 'রক্তের গ্রুপ*',
	selected: {
		option: '----',
		value: '',
	},
	options: ['জানা নেই', 'A+', 'A-', 'AB+', 'AB-', 'B+', 'B-', 'O+', 'O-'],
};

export const allDivision = {
	label: 'বিভাগ',
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'ঢাকা বিভাগ',
		'চট্টগ্রাম বিভাগ',
		'রাজশাহী বিভাগ',
		'খুলনা বিভাগ',
		'বরিশাল বিভাগ',
		'সিলেট বিভাগ',
		'রংপুর বিভাগ',
		'ময়মনসিংহ বিভাগ',
	],
};

export const allDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'বাগেরহাট',
		'বান্দরবান',
		'বরগুনা',
		'বরিশাল',
		'ভোলা',
		'বগুড়া',
		'ব্রাহ্মণবাড়িয়া',
		'চাঁদপুর',
		'চাঁপাইনবাবগঞ্জ',
		'চট্টগ্রাম',
		'চুয়াডাঙ্গা',
		'কক্স বাজার',
		'কুমিল্লা',
		'ঢাকা',
		'দিনাজপুর',
		'ফরিদপুর',
		'ফেনী',
		'গাইবান্ধা',
		'গাজীপুর',
		'গোপালগঞ্জ',
		'হবিগঞ্জ',
		'জামালপুর',
		'যশোর',
		'ঝালকাঠী',
		'ঝিনাইদহ',
		'জয়পুরহাট',
		'খাগড়াছড়ি',
		'খুলনা',
		'কিশোরগঞ্জ',
		'কুড়িগ্রাম',
		'কুষ্টিয়া',
		'লক্ষ্মীপুর',
		'লালমনিরহাট',
		'মাদারীপুর',
		'মাগুরা',
		'মানিকগঞ্জ',
		'মেহেরপুর',
		'মৌলভীবাজার',
		'মুন্সিগঞ্জ',
		'ময়মনসিংহ',
		'নওগাঁ',
		'নড়াইল',
		'নারায়ণগঞ্জ',
		'নরসিংদী',
		'নাটোর',
		'নেত্রকোনা',
		'নিলফামারী',
		'নোয়াখালী',
		'পাবনা',
		'পঞ্চগড়',
		'পটুয়াখালী',
		'পিরোজপুর',
		'রাজবাড়ী',
		'রাজশাহী',
		'রাঙ্গামাটি',
		'রংপুর',
		'সাতক্ষীরা',
		'শরিয়তপুর',
		'শেরপুর',
		'সিরাজগঞ্জ',
		'সুনামগঞ্জ',
		'সিলেট',
		'টাঙ্গাইল',
		'ঠাকুরগাঁও',
	],
};

export const dhakaDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'নরসিংদী',
		'গাজীপুর',
		'শরীয়তপুর',
		'নারায়ণগঞ্জ',
		'টাঙ্গাইল',
		'কিশোরগঞ্জ',
		'মানিকগঞ্জ',
		'ঢাকা',
		'মুন্সিগঞ্জ',
		'রাজবাড়ী',
		'মাদারীপুর',
		'গোপালগঞ্জ',
		'ফরিদপুর',
	],
};

export const chittagongDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'কুমিল্লা',
		'ফেনী',
		'ব্রাহ্মণবাড়িয়া',
		'রাঙ্গামাটি',
		'নোয়াখালী',
		'চাঁদপুর',
		'লক্ষ্মীপুর',
		'চট্টগ্রাম',
		'কক্স বাজার',
		'খাগড়াছড়ি',
		'বান্দরবান',
	],
};

export const rajshahiDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'সিরাজগঞ্জ',
		'পাবনা',
		'বগুড়া',
		'রাজশাহী',
		'নাটোর',
		'জয়পুরহাট',
		'চাঁপাইনবাবগঞ্জ',
		'নওগাঁ',
	],
};

export const khulnaDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'যশোর',
		'সাতক্ষীরা',
		'মেহেরপুর',
		'নড়াইল',
		'চুয়াডাঙ্গা',
		'কুষ্টিয়া',
		'মাগুরা',
		'খুলনা',
		'বাগেরহাট',
		'ঝিনাইদহ',
	],
};
export const barishalDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: ['ঝালকাঠী', 'পটুয়াখালী', 'পিরোজপুর', 'বরিশাল', 'ভোলা', 'বরগুনা'],
};

export const sylhetDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: ['সিলেট', 'মৌলভীবাজার', 'হবিগঞ্জ', 'সুনামগঞ্জ'],
};

export const rangpurDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: [
		'পঞ্চগড়',
		'দিনাজপুর',
		'লালমনিরহাট',
		'নীলফামারী',
		'গাইবান্ধা',
		'ঠাকুরগাঁও',
		'রংপুর',
		'কুড়িগ্রাম',
	],
};

export const moymonsinghDistrict = {
	selected: {
		option: '----',
		value: '',
	},
	options: ['শেরপুর', 'ময়মনসিংহ', 'জামালপুর', 'নেত্রকোনা'],
};

// create district Map
export const district = new Map();

district.set('সকল বিভাগ', allDistrict);
district.set('ঢাকা বিভাগ', dhakaDistrict);
district.set('চট্টগ্রাম বিভাগ', chittagongDistrict);
district.set('রাজশাহী বিভাগ', rajshahiDistrict);
district.set('খুলনা বিভাগ', khulnaDistrict);
district.set('বরিশাল বিভাগ', barishalDistrict);
district.set('সিলেট বিভাগ', sylhetDistrict);
district.set('রংপুর বিভাগ', rangpurDistrict);
district.set('ময়মনসিংহ বিভাগ', moymonsinghDistrict);